import {
    createSlice,
    isPending,
    isRejected,
    isFulfilled
} from '@reduxjs/toolkit';

const uiSlice = createSlice({
    name: 'ui',
    initialState: {
        loading: false,
        error: null
    },
    reducers: {
        clearError: (state) => {
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addMatcher(isPending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addMatcher(isFulfilled, (state) => {
                state.loading = false;
            })
            .addMatcher(isRejected, (state, action) => {
                state.loading = false;
                state.error =
                    action.payload ||
                    action.error?.message ||
                    'Error inesperado';
            });
    }
});

export const { clearError } = uiSlice.actions;
export default uiSlice.reducer;
